import axios from "../axios"

const userApi = {
	getUserCompany() { //获取当前账号企业基本信息
		return axios({
			url: `/gzeua/Company/GetCurCompanyByCurUserId`,
			method: "post",
		})
	},

	getShowByBaseCompanyId(baseCompanyId) { //根据id获取企业基本信息
		return axios({
			// url: `/gzeua/Company/GetShowByBaseCompanyId`,
			url: `/gzeua/Company/GetComanyByBaseCompanyId`,
			method: "post",
			params: {
				baseCompanyId
			}
		})
	},

	saveCompany(data) { //编辑企业信息
		return axios({
			url: `/gzeua/Company/SaveCompany`,
			method: "post",
			data
		})
	},
	getIndustryTree(data) { //获取行业树
		return axios({
			url: `http://221.10.90.153:8082/cibc/LoginWithKey/GetIndustryTree?key=WE8N9D0V8BN40SLFO43P`,
			method: "post",
			data
		})
	},
	getQueryGKLX(data) { //获取管控类型
		return axios({
			url: `/gzeua/Company/QueryGKLX`,
			method: "post",
			data
		})
	},
	getQueryPWLX(data) { //
		return axios({
			url: `/gzeua/Company/QueryPWLX`,
			method: "post",
			data
		})
	},
	getQueryQYLX(data) { //
		return axios({
			url: `/gzeua/Company/QueryQYLX`,
			method: "post",
			data
		})
	},
	saveCard(data) { //
		return axios({
			url: `http://221.10.90.153:8082/cibc/Company/SaveCard?id=${data.id}&id2=${data.id2}`,
			method: "post",
			data: data.file
		})
	},
	savePhoto(data) { //
		return axios({
			url: `http://221.10.90.153:8082/cibc/Company/SavePhoto?id=${data.id}&id2=${data.id2}`,
			method: "post",
			data: data.file
		})
	},
	getIndustryTree(data) { //获取行业树
		return axios({
			url: `http://221.10.90.153:8082/cibc/LoginWithKey/GetIndustryTree?key=WE8N9D0V8BN40SLFO43P`,
			method: "post",
			data
		})
	},

	saveCompanyInfo(data) { //
		return axios({
			url: `/gzeua/Company/CreateOrEdit`,
			method: "post",
			data
		})
	},

	getGZCompanies(data) { //编辑企业信息
		return axios({
			url: `/gzeua/Company/QueryRegionCompany`,
			method: "post",
			data
		})
	},
	getGZRegionTree(data) { //编辑企业信息
		return axios({
			url: `/gzeua/ERegionr/GetRegionGZ`,
			method: "post",
			data
		})
	},


	getManageToolMenu() { //查询行政区域
		return axios({
			url: `/gzeua/Region/GetManageToolMenu`,
			method: "post",
		})
	},

	getRegionChildern(id) { //查询行政区域byId
		return axios({
			url: `/gzeua/Region/GetChildern`,
			method: "post",
			params: {
				id
			}
		})
	},

	getRegionSheng() { //查询直辖市
		return axios({
			url: `/gzeua/Region/GetSheng`,
			method: "post",
		})
	},

	getregionFullNameStr(id) { //查询行政区域fullname
		return axios({
			url: `/gzeua/Region/GetFullNameStr`,
			method: "post",
			params: {
				id
			}
		})
	},
	getregionStreet(xian) { //查询街道
		return axios({
			url: `/gzeua/Region/QueryRegionLoadList`,
			method: "post",
			params: {
				xian
			}
		})
	},

	saveRegion(data) { //保存行政区域
		return axios({
			url: `/gzeua/Region/CreateAndUpdateSave`,
			method: "post",
			data
		})
	},

	deleteRegion(id) { //删除行政区域
		return axios({
			url: `/gzeua/Region/Delete`,
			method: "post",
			params: {
				id
			}
		})
	},


	uploadFile(path,secondPath,fileName, formData) {
		return axios({
			url: `/file`,
			method: "post",
			params: {
				path,secondPath,fileName
			},
			data: formData
		})
	},

	searchIndustryCategory(id) { //根据父级id查询行业
		return axios({
			url: `/gzeua/BIndustryCategory/Search`,
			method: "post",
			params: {
				id
			}
		})
	},

	saveCategory(data) { //保存行业
		return axios({
			url: `/gzeua/BIndustryCategory/CreateAndUpdateSave`,
			method: "post",
			data
		})
	},

	deleteCategory(id) { //删除行业
		return axios({
			url: `/gzeua/BIndustryCategory/Delete`,
			method: "post",
			params: {
				id
			}
		})
	},

	

	queryForOpen(data) { //查询所有公开
		return axios({
			url: `/gzeua/YearsInfo/QueryForOpen`,
			method: "post",
			data
		})
	},

	getEditById(infoId) {
		return axios({
			url: `api/YearsInfo/GetEditById`,
			method: "post",
			params: {
				infoId
			}
		})
	},

	queryCompanyAppraise(data) { //结果公布
		return axios({
			url: `/gzeua/CompanyAppraise/QueryByParam`,
			method: "post",
			data
		})
	},

	queryECAAppraise(data) { //结果公示
		return axios({
			url: `/gzeua/ECAAppraise/Query`,
			method: "post",
			data
		})
	},
	
	companyQuery(data) { //企业基本信息筛选
		return axios({
			url: `/gzeua/Company/CompanyQuery`,
			method: "post",
			data
		})
	},
	baseCompanyQuery(data) { //企业基本信息筛选
		return axios({
			url: `/gzeua/Company/BaseCompanyQuery`,
			method: "post",
			data
		})
	},
}
export default userApi
